import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
import {
  NO_ORDERS_BEING_ACCEPTED_AT_THIS_TIME,
  PREVIEW_MENU
} from 'constants/previewMenu';
import LocationCardFulfillmentTypeGridItem from 'components/Location/LocationCardFulfillmentTypeGridItem';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import LocationCardFulfillmentMethod from 'components/Location/LocationCardFulfillmentMethod';

const LocationCardPreviewMenu = ({
  beginOrder,
  isAcceptingPickupOrders,
  isAcceptingDeliveryOrders
}) => {
  const getFulfillmentType = () => {
    let fulfillmentType = '';

    if (isAcceptingPickupOrders && isAcceptingDeliveryOrders) {
      fulfillmentType = fulfillmentOptions.PICKUP;
    } else if (isAcceptingDeliveryOrders) {
      fulfillmentType = fulfillmentOptions.DELIVERY;
    } else if (isAcceptingPickupOrders) {
      fulfillmentType = fulfillmentOptions.PICKUP;
    }

    return fulfillmentType;
  };

  const fulfillmentType = getFulfillmentType();

  return (
    <LocationCardFulfillmentTypeGridItem>
      <MenuItemDescriptionTypography variant={ITEM_DESCRIPTION_AND_PRICES}>
        <LocationCardFulfillmentMethod
          isFullWidth
          buttonLabel={PREVIEW_MENU}
          handleButtonClick={() => beginOrder(fulfillmentType)}
        />
        <Box mt={1}>{NO_ORDERS_BEING_ACCEPTED_AT_THIS_TIME}</Box>
      </MenuItemDescriptionTypography>
    </LocationCardFulfillmentTypeGridItem>
  );
};

LocationCardPreviewMenu.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  isAcceptingDeliveryOrders: PropTypes.bool.isRequired,
  isAcceptingPickupOrders: PropTypes.bool.isRequired
};

export default LocationCardPreviewMenu;
